import { Language, OpeningDate, DeliveryOpeningDate } from "@hilma/netina2all";
import { generateOpeningDateSave } from "../constants";
import { openingDate, OpenStationDetails, StationDetailKey, StationManagementDetails, StationSectionDataField, StationValueType } from "../types";
import { formatOpeningDate, formatTimeRange } from "./formatTimeRange";

export const createOpeningSectionData = (
    openingDateArr: OpeningDate[] | DeliveryOpeningDate[] | null,
    details: StationManagementDetails | null,
    language: Language,
    type: openingDate
): StationSectionDataField[] => {

    const openingDateRules = (item: OpeningDate) => generateOpeningDateSave(!!item.isFriday, !!item.isSaturday).timeRange;
    const propertyName = type === 'opening-date' ? 'openingDates' : 'deliveryOpeningDates';

    return (
        !openingDateArr ?
            [...Array(2)].map((_, i) => ({
                description: '',
                id: '' + i
            })) :
            openingDateArr!.map(x => ({
                description: formatOpeningDate(x.date, language),
                id: '' + x.id,
                isEditable: true,
                value: formatTimeRange(details?.[propertyName].find(y => y.openingDateId === x.id)?.timeRange, language),
                timeRange: details?.[propertyName].find(y => y.openingDateId === x.id)?.timeRange,
                rules: { ['' + x.id]: openingDateRules(x) },
                byAppointment: details?.[propertyName].find(y => y.openingDateId === x.id)?.byAppointment
            }))
    )
}

export const createSectionDataField = (
    item: OpenStationDetails,
    details: StationManagementDetails | null,
): StationSectionDataField[] => {
    return (
        item.data.map(x => ({
            ...x,
            ...(details ? { value: details[x.id as StationDetailKey] as StationValueType } : {})
        }))
    )
}